import { useTheme } from '@heypongo/brick'

import { getContrast } from '@/utils/color'

import type { GameContest } from '@/types/index'

interface UseMerchantReturn {
  setThemeColor: (contest?: GameContest) => void
}

export default function useMerchant(): UseMerchantReturn {
  const { setColor } = useTheme()

  const setThemeColor = (contest?: GameContest) => {
    return setColor({
      primary: contest?.buttonColor,
      theme: null,
      secondary: getContrast(contest?.buttonColor),
    })
  }

  return { setThemeColor }
}
